import { useQuery } from 'react-query';
import { PlanDetailsResponse } from '@monovo/ev-anytime';
import { fetchFn } from '../services/chargeAnytimeAPI';

export const usePlanDetailsQuery = (enabled: boolean, accountId: string) => {
  return useQuery<PlanDetailsResponse, unknown>({
    queryKey: `charge-anytime-plan-details-${accountId}`,
    enabled: enabled && !!accountId,
    retryOnMount: false,
    queryFn: () => {
      return fetchFn(`/v0/charge-anytime/accounts/${accountId}/plan-details`, {
        method: 'get',
      });
    },
  });
};
